import { render } from "./ListComponent.vue?vue&type=template&id=ca5e7434&ts=true"
import script from "./ListComponent.vue?vue&type=script&lang=ts"
export * from "./ListComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__